/// <reference path="../_all.ts" />

declare var pglob : IPhotometerGlobalVar;

module library {
  'use strict';
  
  export class ProductFilterCtrl {

    public static $inject = [
      '$scope',
      '$timeout',
      '$mdPanel',
      '$interval',
    ];

    constructor(
      private $scope: IProductFilterCtrlScope
      , private $timeout: ng.ITimeoutService
      , private $mdPanel : ng.material.IPanelService
      , private $interval: ng.IIntervalService
      ) {

      $scope.vm = this;

      if (this.selected) {
        this.selected.forEach((el, i, arr) => {
          this.selectedProducts[el] = true;
        });
      }
      
      

      //this.$timeout(function() {
      //  var selected = document.querySelector('.demo-menu-item.selected');
      //  if (selected) {
      //    angular.element(selected).focus();
      //  } else {
      //    angular.element(document.querySelectorAll('.demo-menu-item')[0]).focus();
      //  }
      //});
    }

    products : search.Product[];
    selected : number[];
    selectedProducts : { [id: number] : boolean; } = {};
    mdPanelRef : ng.material.IPanelRef;
    
    //selectProduct(product) {
    //  this.selected = dessert;
    //  this._mdPanelRef && this._mdPanelRef.close().then(function() {
    //    angular.element(document.querySelector('.demo-menu-open-button')).focus();
    //  });
    //}

    //onKeydown($event, dessert) {
    //  var handled, els, index, prevIndex, nextIndex;
    //  switch ($event.which) {
    //    case 38: // Up Arrow.
    //      els = document.querySelectorAll('.demo-menu-item');
    //      index = indexOf(els, document.activeElement);
    //      prevIndex = (index + els.length - 1) % els.length;
    //      els[prevIndex].focus();
    //      handled = true;
    //      break;

    //    case 40: // Down Arrow.
    //      els = document.querySelectorAll('.demo-menu-item');
    //      index = indexOf(els, document.activeElement);
    //      nextIndex = (index + 1) % els.length;
    //      els[nextIndex].focus();
    //      handled = true;
    //      break;

    //    case 13: // Enter.
    //    case 32: // Space.
    //      this.selectDessert(dessert);
    //      handled = true;
    //      break;

    //    case 9: // Tab.
    //      this._mdPanelRef && this._mdPanelRef.close();
    //  }

    //  if (handled) {
    //    $event.preventDefault();
    //    $event.stopImmediatePropagation();
    //  }

    //  function indexOf(nodeList, element) {
    //    for (var item, i = 0; item = nodeList[i]; i++) {
    //      if (item === element) {
    //        return i;
    //      }
    //    }
    //    return -1;
    //  }
    //}

    selectAll() {  
      
      this.$scope.filteredProducts.forEach((el, i, arr) => {
        this.selectedProducts[el.Id] = true;
      });
    }

    selectNone() {     
      this.products.forEach((el, i, arr) => {
        this.selectedProducts[el.Id] = false;
      });
    }

    close() {
      this.selected.length = 0;
      for (var key in this.selectedProducts) {
        if (this.selectedProducts[key]) this.selected.push(parseInt(key));
      }

      if (this.mdPanelRef) this.mdPanelRef.close();
    }

    count() {
      let count = 0;
      for (var key in this.selectedProducts) {
        if (this.selectedProducts[key]) count++;
      }
      return count;
    }
    
  }
}




